import {
  Box,
  Divider,
  Drawer,
  Stack,
  SvgIcon,
  useMediaQuery,
} from '@mui/material';
import { NavLink } from 'react-router-dom';

import { useUiStore } from '@/store/ui/ui.store';
import {MagnifyingGlassIcon, XMarkIcon} from "@heroicons/react/24/solid";
import { useState } from 'react';
import { Scrollbar } from '../Scrollbar';
import CustomMenuItem from './CustomMenuItem';
import './SideNav.css';
import { NestedMenuItem, useNestedMenu } from './useNestedMenu';
import { getEnvs } from '@/shared/utils/get-envs';

const {
  VITE_LOGO_EVA_DASHBOARD,
} = getEnvs()

export type SideNavProps = {};

const SideNav: React.FC<SideNavProps> = () => {
  //zustand
  const isOpen = useUiStore(s => s.openNav);
  const setOpen = useUiStore(s => s.setOpenNav);

  //customs hooks
  const { nestedMenuItesm } = useNestedMenu();

  //local states
  const [searchModule, setSearchModule] = useState<string>('');
  const [nestedItem, setNestedItem] =
    useState<NestedMenuItem[]>(nestedMenuItesm);


  //Events
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const valor = event.target.value;
    setSearchModule(valor);
    const resultados = searchByTitle(nestedMenuItesm, valor);
    if (valor) {
      setNestedItem(resultados);
    } else {
      setNestedItem(nestedMenuItesm);
    }
  };

  //functions
  function searchByTitle(
    arr: NestedMenuItem[],
    titulo: string
  ): NestedMenuItem[] {
    const resultados: NestedMenuItem[] = [];
    for (const item of arr) {
      if (item.title.toLowerCase().includes(titulo.toLowerCase())) {
        resultados.push(item);
      }
      if (item.items && item.items.length > 0) {
        const encontrados = searchByTitle(item.items, titulo);
        resultados.push(...encontrados);
      }
    }
    return resultados;
  }

  ///* content
  const content = (
    <Scrollbar
      sx={{
        height: '100%',
        '& .simplebar-content': {
          height: '100%',
        },
        '& .simplebar-scrollbar:before': {
          background: '#D2D6DB',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
        }}
      >
        <Box sx={{ p: 3 }}>
          {/* ============= Top box - Logo ============= */}
          <Box
            sx={{
              alignItems: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.04)',
              borderRadius: 1,
              cursor: 'pointer',
              display: 'flex',
              justifyContent: 'center',
              mt: 2,
              p: '12px',
            }}
          >
            
            <Box
              component={NavLink}
              to="/"
              sx={{
                display: 'inline-flex',
                height: 40,
                width: 108,
              }}
            >
              {<img src={VITE_LOGO_EVA_DASHBOARD} alt="logo" style={{color:'white'}} />}
            </Box>
          </Box>
        </Box>
        <Divider sx={{ borderColor: 'neutral.700' }} />

        {/* ============= menu ============= */}
        <Box
          component="nav"
          sx={{
            flexGrow: 1,
            px: 2,
            py: 3,
          }}
        >
          <Stack
            component="ul"
            spacing={0.5}
            sx={{
              listStyle: 'none',
              p: 0,
              m: 0,
            }}
          >
            <div className="input-icon-container">
              <span className="icon">
                <SvgIcon color="action" fontSize="small">
                  <MagnifyingGlassIcon />
                </SvgIcon>
              </span>
              <input
                type="text"
                autoComplete='off'
                className="selector"
                value={searchModule}
                placeholder="Buscar"
                onChange={handleChange}
              ></input>
              {
                searchModule.length > 0 ?
                  <span
                    onClick={() => { setNestedItem(nestedMenuItesm); setSearchModule("") }}
                    style={{ display: "flex", justifyContent: "end", cursor: "pointer" }}>
                    <SvgIcon color="action" fontSize="small">
                      <XMarkIcon />
                    </SvgIcon>
                  </span>
                  : null
              }
            </div>

            {/* ------ Menu Items ------ */}
            {nestedItem.map((item, key) => {
              // check if item is null <-- permission first level item
              if (!item) return null;

              return <CustomMenuItem key={key} item={item} />;
            })}
          </Stack>
        </Box>
      </Box>
    </Scrollbar>
  );

  const lgUp = useMediaQuery(theme => (theme as any).breakpoints.up('lg'));

  if (!isOpen && !lgUp) return null;
  //if (isOpen && lgUp) return null;


  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: 'neutral.800',
            color: 'common.white',
            transition: 'width .5s ease',
            width: isOpen ? 0 : 280,
          },
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={() => setOpen(false)}
      open={isOpen}
      PaperProps={{
        sx: {
          backgroundColor: 'neutral.800',
          color: 'common.white',
          width: 280,
          transition: 'all 2s ease',
        },
      }}
      sx={{ zIndex: theme => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );

};

export default SideNav;
